var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchiveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.8 2.369c0-.917.7-1.66 1.7-1.66h13.2c.9 0 1.7.743 1.7 1.66v2.49c0 .615-.3 1.151-.8 1.438v8.523c0 1.375-1.2 2.49-2.5 2.49h-10c-1.4 0-2.5-1.115-2.5-2.49V6.297C1.1 6.01.8 5.474.8 4.859v-2.49Zm4.1 4.15h10v8.301c0 .458-.4.83-.8.83h-10c-.4 0-.8-.372-.8-.83V6.519h1.6Zm10.8-2.49v.83H2.5V2.369h13.2v1.66ZM6.6 8.18c-.5 0-.8.371-.8.83 0 .458.3.83.8.83h5c.4 0 .8-.372.8-.83 0-.459-.4-.83-.8-.83h-5Z",
  fill: "currentColor"
})));
export { SvgArchiveIcon as ReactComponent };
export default __webpack_public_path__ + "images/archive-icon.svg";